// extracted by mini-css-extract-plugin
export var ctaButton = "TextSliderCta-module--ctaButton--415f0";
export var ctaWrapper = "TextSliderCta-module--ctaWrapper--55449";
export var title = "TextSliderCta-module--title--cf309";
export var wrapper = "TextSliderCta-module--wrapper--021fa";